/* React */
import React from "react";

/* Components */
import Select from "src/components/insights/custom-cohorts/cohort-builder/entity-selector/select/Select";

/* Stylesheet */
import styles from "./EntitySelector.module.scss";

/* Interfaces */
import { BasicProps } from "src/shared/interfaces/custom-cohorts/CustomCohorts";

interface CustomEntitiesProps {
  value: string;
  featureTypes: BasicProps[];
  disabled: boolean;
  handleSegments: (segment: BasicProps) => void;
}

const EntitySelector: React.FC<CustomEntitiesProps> = ({
  value,
  featureTypes,
  disabled,
  handleSegments,
}) => {
  const handleOnClick = (item: BasicProps) => {
    handleSegments(item);
  };

  return (
    <div className={styles.entity_selector}>
      <Select
        label={"Entity name"}
        value={value}
        items={featureTypes}
        disabled={disabled}
        onClick={handleOnClick}
      />
    </div>
  );
};

export default EntitySelector;
